import { combineReducers } from 'redux';
import activeFormReducer from './activeFormReducer';
import portalDataReducer from './portalDataReducer';

const rootReducer = combineReducers({
  activeFormReducer,
  portalDataReducer
});

export default rootReducer;